/**
 * The active backend.
 *
 * The sync layer must not import an adapter directly — that is the whole point
 * of the port — so the adapter is registered once at start-up (`src/wiring.ts`)
 * and looked up lazily here. One store at a time: a company's archive lives in
 * exactly one place, and switching means connecting the new one and disconnecting
 * the old — never a fallback from one to the other.
 */
import type { RemoteStore } from './types';

let active: RemoteStore | null = null;

export function setRemoteStore(store: RemoteStore | null): void {
  active = store;
}

/** The active store, or null when no backend is configured (Drive not set up). */
export function remoteStore(): RemoteStore | null {
  return active;
}

/**
 * The active store, or a throw. Call this from code that only runs once the
 * user has connected a backend; use `remoteStore()` where "not connected" is a
 * normal state to render.
 */
export function getRemoteStore(): RemoteStore {
  if (!active) throw new Error('No remote store configured; call setRemoteStore() at start-up');
  return active;
}
